module.exports = __webpack_public_path__ + "img/manager.63c49da3.svg";